<template>
	<header v-bind:class="{'in-intro':headerpos==='intro' && feed==='main','autoplaying' : slideauto,'static' : !slideauto}">
		<div class="decades" v-bind:class="{
			'decade-1920': activeDecade === '1920' && headerpos!=='intro',
			'decade-1930': activeDecade === '1930' && headerpos!=='intro',
			'decade-1940': activeDecade === '1940' && headerpos!=='intro',
			'decade-1950': activeDecade === '1950' && headerpos!=='intro',
			'decade-1960': activeDecade === '1960' && headerpos!=='intro',
			'decade-1970': activeDecade === '1970' && headerpos!=='intro',
			'decade-1980': activeDecade === '1980' && headerpos!=='intro',
			'decade-1990': activeDecade === '1990' && headerpos!=='intro',
			'decade-2000': activeDecade === '2000' && headerpos!=='intro',
			'decade-2010': activeDecade === '2010' && headerpos!=='intro'
		}">
			<div class="scrollProgress" v-bind:class="'decade-'+activeDecade">
				<div class="scrollIndicator" v-bind:class="{'is-scrolling' : isScrolling === true }" :style="{'transform': 'translateX(' + lPos + '%)'}"></div>
			</div>
			<ul class="filter-decade tbs">
				<li v-bind:class="{'active' : feed !== 'ps1' && slideactive === 0}" class="decade-1920 intro-ani-1" v-if="feed !== 'ps1'">
					<a :href="rootPath + '1920/'" v-on:click.stop.prevent="jumpTo('1920')">1920s<span class="active-over-mask">1920s</span></a>
				</li>
				<li v-bind:class="{'active' : feed !== 'ps1' && slideactive === 1}" class="decade-1930 intro-ani-2" v-if="feed !== 'ps1'">
					<a :href="rootPath + '1930/'" v-on:click.stop.prevent="jumpTo('1930')">1930s<span class="active-over-mask">1930s</span></a>
				</li>
				<li v-bind:class="{'active' : feed !== 'ps1' && slideactive === 2}" class="decade-1940 intro-ani-3" v-if="feed !== 'ps1'">
					<a :href="rootPath + '1940/'" v-on:click.stop.prevent="jumpTo('1940')">1940s<span class="active-over-mask">1940s</span></a>
				</li>
				<li v-bind:class="{'active' : feed !== 'ps1' && slideactive === 3}" class="decade-1950 intro-ani-4" v-if="feed !== 'ps1'">
					<a :href="rootPath + '1950/'" v-on:click.stop.prevent="jumpTo('1950')">1950s<span class="active-over-mask">1950s</span></a>
				</li>
				<li v-bind:class="{'active' : feed !== 'ps1' && slideactive === 4}" class="decade-1960 intro-ani-5" v-if="feed !== 'ps1'">
					<a :href="rootPath + '1960/'" v-on:click.stop.prevent="jumpTo('1960')">1960s<span class="active-over-mask">1960s</span></a>
				</li>
				<li v-bind:class="{'active' : feed !== 'ps1' && slideactive === 5}" class="decade-1970 intro-ani-6">
					<a :href="rootPath + '1970/'" v-on:click.stop.prevent="jumpTo('1970')">1970s<span class="active-over-mask">1970s</span></a>
				</li>
				<li v-bind:class="{'active' : feed !== 'ps1' && slideactive === 6}" class="decade-1980 intro-ani-7">
					<a :href="rootPath + '1980/'" v-on:click.stop.prevent="jumpTo('1980')">1980s<span class="active-over-mask">1980s</span></a>
				</li>
				<li v-bind:class="{'active' : feed !== 'ps1' && slideactive === 7}" class="decade-1990 intro-ani-8">
					<a :href="rootPath + '1990/'" v-on:click.stop.prevent="jumpTo('1990')">1990s<span class="active-over-mask">1990s</span></a>
				</li>
				<li v-bind:class="{'active' : feed !== 'ps1' && slideactive === 8}" class="exp decade-2000 intro-ani-9">
					<a :href="rootPath + '2000/'" v-on:click.stop.prevent="jumpTo('2000')">2000s<span class="active-over-mask">2000s</span></a>
				</li>
				<li v-bind:class="{'active' : feed !== 'ps1' && slideactive === 9}" class="exp decade-2010 intro-ani-10">
					<a :href="rootPath + '2010/'" v-on:click.stop.prevent="jumpTo('2010')">2010s<span class="active-over-mask">2010s</span></a>
				</li>
			</ul>
			
			<div class="mobile-menu-dropdown" v-on:click="filtersOn = !filtersOn"></div>
		</div>
		<div class="filter-dropdown" v-bind:class="{'filterOn' : filtersOn===true}">
			<span class="blok filter-header">Filter timeline:</span>
			<span class="blok action-link" v-on:click="setFilter('main')">All</span>
			<span class="blok action-link" v-bind:class="{'active' : feed === 'MoMA'}" v-on:click="setFilter('moma')">The Museum of Modern Art</span>
			<span class="blok action-link" v-bind:class="{'active' : feed === 'MoMAPS1'}" v-on:click="setFilter('ps1')">MoMA PS1</span>
		</div>
	</header>
</template>

<script>
import Flickity from 'flickity';
var $ = require('jquery');
export default {
	name: "Header",
	props: ['rootPath','apiPath','feed','headerpos','lPos','activeDecade','isScrolling'],
	data() {
		return {
			publicPath: process.env.BASE_URL,
			filtersOn:false,
			timebarEl:null,
			timebarIntro:null,
			decadeList : [
				'1920',
				'1930',
				'1940',
				'1950',
				'1960',
				'1970',
				'1980',
				'1990',
				'2000',
				'2010',
			]
		};
	},
	mounted() {
		let scopeThis = this;
		scopeThis.timebarEl = document.querySelector('.filter-decade');
		scopeThis.timebarIntro = new Flickity(scopeThis.timebarEl, {
			cellAlign: 'center',
			pageDots: false,
			prevNextButtons: false,
			freeScroll: true,
			watchCSS: true
		});
	},
	computed: {
		slideactive:function(){
			return this.$root.$data.introActive;
		},
		slideauto:function(){
			return this.$root.$data.introAuto;
		},
		
	},
	watch: {
		// call again the method if the route changes
		activeDecade: "updateDecade",
		headerpos: "updateDecade"
	},	
	methods: {
		updateDecade(){
			let scopeThis = this;
			// console.log("New decade: " + this.activeDecade + ", in intro " + this.headerpos);
			if(this.headerpos !== "intro"){
				let decadeIndex = scopeThis.decadeList.indexOf(scopeThis.activeDecade);
				if(decadeIndex >= 0){
					scopeThis.timebarIntro.select(decadeIndex);
				}
			}
		},
		setFilter(newFilter) {
			this.$parent.feed = newFilter;
			this.filtersOn = false;
			document.body.scrollTop = document.documentElement.scrollTop = 0;
			let newURL = '';
			if(newFilter === 'ps1'){
				newURL = 'moma-ps1/';
			} else if(newFilter === 'moma'){
				newURL = 'moma/';
			}
			this.$parent.setNewURL(
				this.publicPath +
					newURL
			);
		},
		jumpTo(whatDecade) {
			// document.querySelector('.hello').scrollIntoView({ 
			//   behavior: 'smooth' 
			// });
			$('html').css({'scroll-behavior': 'smooth'});
			document.body.scrollTop = document.documentElement.scrollTop = $(".stop-"+whatDecade).first().offset().top - 90;
			// document.body.scrollTop = document.documentElement.scrollTop = document.querySelector(".decade-sep-"+whatDecade).offsetTop - 90;
		}
	}
};
</script>

<style lang="scss">
@import "../sass/_mq.scss";
header {
	animation:headerDown 1s 0s forwards 1;
	transition-duration:0.2s;
	transition-delay:0.3s;
	background:rgba(255, 255, 255, 0.94);

	ul.filter-decade {
		position:relative;
		transition-duration:0.2s;
		transition-delay:0.3s;
		margin-right:15px;
		padding:10px 0 7px;
		@include tabletBelow {
			padding-bottom:2px;
		}
	}
	.filter-header {
		font-size: 15px;
		font-weight:normal;
		margin: 0.2em 0 0.4em;
	}
	&.in-intro {
		animation:headerUp 1s 0s forwards 1;
		background:none;
		color:white;
		transition-delay:0s;
		transition-duration:0s;
		ul.filter-decade {
			// transition-delay:0s;
			transition-duration:0s;
			margin-right:0;
		}
	}
	@include tabletBelow {
		.filter-decade {
			width:100%;
			overflow-x:auto;
			overflow-y:visible;
			-webkit-overflow-scrolling: touch;
		}
	}
}
ul.filter-decade {
	list-style:none;
	padding:0;
	margin:0 15px 0 0;
	display:flex;
	justify-content:space-between;
	align-items:center;
	flex-wrap:nowrap;
	transition-duration:0.5s;
	&:after {
		content: 'flickity';
		display: none; /* hide :after */
	}

	@media screen and ( min-width: 768px ) {
		display:flex;
		/* disable Flickity for large devices */
		&:after {
			content: '';
		}
	}
	&.flickity-enabled {
		display: block;
	}
	&.hide-filters {
		opacity:0;
	}
	li {
		position:relative;
		padding:6px 0 10px;
		flex-basis:10%;
		text-align:center;
		transition-duration:1s;
		margin-left:auto;
		margin-right:auto;
		&:first-child, &.menu-dropdown { margin-left:0; }
		&:last-child, &.decade-2010s { margin-right:0; }
		@include tabletBelow {
			padding:4px 0 10px;
		}
		.in-intro & {
			a { color:white; }
		}
	}
	
	a {
		color:black;
		text-decoration: none;
		display:inline-block;
		position:relative;
	}

	@include tabletBelow {
		max-width:100%;
		padding-left:20px;
		li { 
			margin:0 10px;
		}
	}
}
.mobile-menu-dropdown {
	position:absolute;
	top:0;
	right:0;
	width:40px;
	height:100%;
	padding:0;
	background-image:url(../assets/baseline-filter_list-24px.svg);
	background-repeat:no-repeat;
	background-position: 50% 44%;
	background-size:24px auto;
	cursor:pointer;
	z-index: 5;
	backface-visibility:hidden;
	transition-duration:0.2s;
	transition-delay:1.1s;
	.in-intro & {
		opacity:0;
		transition-delay:0s;
	}
	
	&.nochoice {
		opacity:0 !important;
		pointer-events:none;
	}
	@include tabletBelow {
		background-color:white;
		background-position:50% 52%;
	}
}
@keyframes headerDown {
	0% {
		opacity:1;
		transform:translateY(-100%);
	}
	45% {
		opacity:0;
		transform:translateY(-100%);
	}
	55% {
		opacity:0;
		transform:translateY(0%);
	}
	100% {
		opacity:1;
		transform:translateY(0%);
	}
}
@keyframes headerUp {
	0% {
		opacity:1;
		transform:translateY(0);
	}
	45% {
		opacity:0;
		transform:translateY(0);
	}
	55% {
		opacity:0;
		transform:translateY(-100%);
	}
	100% {
		opacity:1;
		transform:translateY(-100%);
	}
}
.active-over-mask {
	position:absolute;
	top:0;
	left:0;
	// top:0;
	// left:0;
	// right:0;
	// bottom:0;
	// top:50%;
	// left:50%;
	// transform:translate(-50%, -50%);
	top:0;
	left:0;
	// width:100%;
	// padding:6px 0 10px;
	overflow:hidden;
	opacity:0;
	transition-duration:0.1s;
	transition-delay:0.2s;
	color:transparent;
	transition-property:opacity;
	display:none;

	.in-intro & {
		display:block;
	}
	.active & {
		opacity:1;
		transition-delay:0s;
		transition-duration:0s;
		// transition-delay:0.1s;
	}
	// top:50%;
	// left:50%;
	// transform:translate(-50%,-50%);
	pointer-events:none;
	backface-visibility:hidden;
	.static.in-intro .active & {
		color: var(--coloractive, inherit);
	}
	.autoplaying.in-intro .active & {
		color: var(--coloractive, inherit);
		animation:wipeRight 6s forwards 1;
	}
}
@keyframes wipeRight {
	0% {
		-webkit-clip-path: polygon(0 0, 100% 0%, 100% 100%, 0 100%);
		clip-path: polygon(0 0, 100% 0%, 100% 100%, 0 100%);
	}
	100% {
		-webkit-clip-path: polygon(100% 0, 100% 0%, 100% 100%, 100% 100%);
		clip-path: polygon(100% 0, 100% 0%, 100% 100%, 100% 100%);
	}
}

</style>